<template>
<div class="publicNumberList">

    <!--<div class="header">-->
        <!--<h1>公众号列表</h1>-->
    <!--</div>-->
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
        <el-menu-item index="1" @click="goto('PublicNumberList')">公众号管理</el-menu-item>
        <el-menu-item index="2" @click="goto('PublicMobile')">模版消息管理</el-menu-item>
        <el-menu-item index="3" @click="goto('MessagePush')">推送消息管理</el-menu-item>
    </el-menu>

    <el-button type="primary" class="add" @click="add()">新增公众号授权</el-button>

    <el-table :data="tableData" class="publicNumberList-table">
        <!--<el-table-column type="selection" width="55px"></el-table-column>-->
        <el-table-column label="用户信息" align="left" width="200">
            <template slot-scope="scope">
                <div class="publicNumberList-name">
                    <template v-if="scope.row.logourl">
                        <img :src="scope.row.logourl" alt="img">
                    </template>
                    <template v-else>
                        <img  src="@/common/images/fansmgt/icon_headerimg.png" alt="img">
                    </template>
                    <p class="a-title">{{scope.row.name}}</p>
                    <p v-if="scope.row.isdefault == 1" class="tag">默认</p>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="principalname" label="主体名称" align="center" >
        </el-table-column>
        <el-table-column prop="mporgid" label="公众号原始ID" align="center"></el-table-column>
        <el-table-column label="公众号类型" align="center">
            <template slot-scope="scope">
                {{scope.row.servicetypeinfo}}（{{scope.row.verifytypeinfo}}）
            </template>
        </el-table-column>
        <el-table-column prop="datetime" label="授权时间" align="center"></el-table-column>

        <el-table-column label="操作" align="right" width="220">

            <template slot-scope="scope">
                <div class="publicNumberList-position">

                    <template v-if="scope.row.isdefault == 0">
                        <el-button type="text" size="small" @click="setDefaultMpaccounts(scope.row.innerid)">设为默认</el-button>
                        <i class="separator">|</i>
                    </template>
                    <el-button type="text" size="small" @click="goto('PublicNumberInfo',scope.row.innerid)">详情</el-button>
                    <!--<i class="separator">|</i>-->
                    <!--<el-button type="text" size="small" @click="goto('/accountMgt/publicNumber/publicMobile?innerid='+scope.row.innerid+'&thdcode='+scope.row.thdcode+'&appid='+scope.row.appid+'&code='+scope.row.code)">模版消息</el-button>-->
                </div>
            </template>


        </el-table-column>
    </el-table>

    <el-pagination
        background
        layout="prev, pager, next"
        :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
    </el-pagination>


    <el-dialog
        title="公众号授权"
        :visible.sync="dialogVisible"
        width="660" height="220">
        <span>请在公众号中完成公众号授权</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="add()">授权失败，重试</el-button>
            <el-button type="primary" @click="apiContent(),dialogVisible = false">授权成功</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {findMpaccountList, getPublicAccount, setDefaultMpaccount} from '@/api/accountApi'
import Loading from 'base/loading/loading'    // 引入 loading 组件
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'PublicNumberList',
    data() {
        return {
            activeIndex: '1',
            token: JSON.parse(sessionStorage['user']).loginToken, // token
            shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            dialogVisible: false,
            loading: false,
            tableData: [],  // 表单数据
            currentPage: 1,     // 初始化页数
            page: 1,            // 页数
            rowCount: 0,        // 数据条数
            apiData: {}         // api数据
        }
    },
    mounted(){
        this.apiContent()
    },
    methods: {
        goto(name,innerid) {
            this.$router.push({name: name,query:{'innerid': innerid}})
        },
        setDefaultMpaccounts(innerid) {
            // 设置默认
            var dafaultData = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                ClientType: 3,
                innerid: innerid
            }
            this.setLoading(true)
            setDefaultMpaccount({
                data: dafaultData,
                success:data => {

                    this.$message.success('设为默认成功')
                    this.setLoading(false)

                    // 重新调用接口 刷新页面
                    this.apiContent()
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        fPage() {
            let clickPage = $(".el-pagination .active").html()
            // this.apiData.page = clickPage
            // 调用模版列表
            this.apiContent(clickPage)
        },
        apiContent(page) {
            // api 连接
            if (page) {
                this.page = page
            }
            this.apiData = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                ClientType: 3,
                page: this.page,
                pageSize: 10
            }
            this.setLoading(true)

            // 公众号列表
            findMpaccountList({
                data: this.apiData,
                success:data => {
                    console.log(data)
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.currentPage = data.data.splitPage.rowCount
                },
                error:data => {
                    this.setLoading(false)
                }
            })
        },
        add() {
            this.dialogVisible = true
            // 授权
            var data = {
                // LoginToken: this.token,
                // ShopID: this.shopID,
                ClientType: 3
            }
            this.setLoading(true)

            getPublicAccount({
                data: data,
                success:data => {
                    console.log(data)
                    this.setLoading(false)
                    window.open(data.data.authurl)
                },
                error: data => {
                    this.setLoading(false)
                }
            })
        },
        ...mapActions ([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Loading
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.publicNumberList {
    .a-title {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: keep-all;
    }
    .el-dialog {
        text-align: center;
        .el-dialog__body {
            padding: 0;
            padding-top: 40px;
        }
        .el-button {
            width: 120px;
            margin: 20px 30px;
        }
    }
    .header {
        border-left: solid 2px #409EFF;
        h1 {
            margin-left: 8px;
            color: #303133;
            font-size: 16px;
            font-weight: bold;
        }
    }
    .add {
        margin-top: 20px;
        width:138px;
        height:36px;
    }
    .tag {
        position: absolute;
        padding: 0 !important;
        margin: 0;
        bottom: 10px;
        left: 20px;
        border-radius: 2px;
        width: 32px;
        height: 16px;
        font-size: 12px;
        color: #fff;
        line-height: 16px;
        text-align: center;
        background: #409EFF;
    }
    span {
        font-size: 14px;
    }
    img {
        float:left;
        width: 50px;
        height: 50px;
        border-radius: 100%;
    }
    .publicNumberList-table {
        width:100%;
        /*min-height: 640px;*/
        text-align:center;
        margin-top: 30px;

        .publicNumberList-name {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: start;
            -ms-flex-pack: start;
            justify-content: flex-start;

            p {
                padding-left: 10px;
            }
        }
        .publicNumberList-position {
            .el-button {
                min-width: auto;
            }
            i {
                margin: 0 10px;
                color: #409EFF;
            }
        }
    }
    .el-pagination {
        margin-top: 20px
    }
}
</style>
